import { ProdutoPacoteModel } from './../../../models/financeiro/produto-pacote.model';
import { Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { HelpConfig } from '@config/help-config';
import { ProdutoRequestModel } from '@core/models/financeiro/produto-request.model';

import { BaseResourceService } from '@core/services/outros/base-resource.service';
@Injectable({
  providedIn: 'root',
})
export class ProdutoService  extends BaseResourceService<ProdutoPacoteModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.FINANCIAL_API}produtos`, injector);
  }

  pacote(resource: ProdutoRequestModel): Observable<ProdutoPacoteModel> {
    return this._httpClient.post<ProdutoPacoteModel>(`${this._url}/pacote`, resource);
  }

  pacoteUpdate(resource: ProdutoRequestModel): Observable<ProdutoPacoteModel> {
    return this._httpClient.put<ProdutoPacoteModel>(`${this._url}/pacote`, resource);
  }

  pacoteById(id: string): Observable<ProdutoPacoteModel> {
    return this._httpClient.get<ProdutoPacoteModel>(`${this._url}/pacote/${id}`,);
  }
}
